<div class="sponsor-details component-viewer">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading" class="progress-bar" />

  <ng-container *ngIf="!isLoading && sponsor?.id">
    <header class="detail-header">
      <div>
        <h1 class="mat-h1 detail-header__title">{{ sponsor.name }}</h1>
        <p class="page-subtitle mat-body-2" *ngIf="sponsor.company">{{ sponsor.company }}</p>
      </div>
    </header>

    <mat-card class="sponsor-card">
      <mat-card-header>
        <mat-card-title>Sponsor details</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <section class="detail-section" aria-label="Sponsorship">
          <h2 class="section-heading mat-subtitle-2">
            <mat-icon class="section-heading__icon" aria-hidden="true">volunteer_activism</mat-icon>
            Sponsorship
            <mat-chip-set class="type-chip" aria-label="Sponsor type">
              <mat-chip highlighted>{{ getSponsorTypeLabel(sponsor.type) }}</mat-chip>
            </mat-chip-set>
          </h2>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">Amount</span>
              <span class="detail-value">
                <ng-container *ngIf="sponsor.amount != null; else noAmount">{{ sponsor.amount | currency }}</ng-container>
                <ng-template #noAmount>—</ng-template>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Has Paid</span>
              <span class="detail-value">
            <true-false [value]="sponsor.hasPaid" [trueText]="'Yes'" [trueMatIcon]="'paid'" [falseText]="'No'" [falseMatIcon]="'error_outline'"></true-false>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Request receipt</span>
              <span class="detail-value">
                <yes-no [value]="sponsor.requestReceipt"></yes-no>
              </span>
            </div>
          </div>
        </section>

        <mat-divider />

        <section class="detail-section" aria-label="Contact information">
          <h2 class="section-heading mat-subtitle-2">
            <mat-icon class="section-heading__icon" aria-hidden="true">person</mat-icon>
            Contact
          </h2>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">Contact email</span>
              <span class="detail-value">
                <a *ngIf="sponsor.contactEmail; else noEmail" [href]="'mailto:' + sponsor.contactEmail">
                  {{ sponsor.contactEmail }}
                </a>
                <ng-template #noEmail>—</ng-template>
              </span>
            </div>
            <div class="detail-item" *ngIf="!sponsor.company">
              <span class="detail-label">Company</span>
              <span class="detail-value">—</span>
            </div>
          </div>
        </section>

        <mat-divider />

        <section class="detail-section" aria-label="Notes">
          <h2 class="section-heading mat-subtitle-2">
            <mat-icon class="section-heading__icon" aria-hidden="true">notes</mat-icon>
            Notes
          </h2>
          <p *ngIf="sponsor.notes?.trim(); else noNotes" class="detail-notes mat-body-1">{{ sponsor.notes }}</p>
          <ng-template #noNotes>
            <span class="detail-value">—</span>
          </ng-template>
        </section>
      </mat-card-content>

      <mat-card-actions align="end" class="detail-actions">
        <button mat-stroked-button type="button" routerLink="/outing-management/administration/sponsors">
          Back to list
        </button>
        <button mat-flat-button color="primary" type="button" [routerLink]="['/outing-management/administration/sponsor/edit', id]">
          <mat-icon>edit</mat-icon>
          Edit sponsor
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>

  <mat-card *ngIf="!isLoading && !sponsor?.id && isGlobalOutingSet()" class="empty-state-card">
    <mat-card-content class="empty-state">
      <mat-icon class="empty-state__icon" aria-hidden="true">search_off</mat-icon>
      <h2 class="mat-h3 empty-state__title">Sponsor not found</h2>
      <p class="mat-body-1 empty-state__text">This sponsor could not be loaded or may have been removed.</p>
      <button mat-stroked-button type="button" routerLink="/outing-management/administration/sponsors">Back to list</button>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!isGlobalOutingSet()" class="empty-state-card">
    <mat-card-content class="empty-state">
      <mat-icon class="empty-state__icon" aria-hidden="true">info</mat-icon>
      <h2 class="mat-h3 empty-state__title">Select an outing</h2>
      <p class="mat-body-1 empty-state__text">Choose an outing and iteration from the header to view sponsor details.</p>
    </mat-card-content>
  </mat-card>
</div>
